<p-toast></p-toast>
<div class="app-report-summary-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-table #reportSummaryTable [value]="reportSummaryTableData" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
          'District',
          'TotalAppRecieved',
          'TotalAppRecievedToday',
          'VerifiedApplication',
          'IncompleteApplication',
          'RejectedApplication',
          'PendingApplication',
          'TotalArea'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="id"
                
currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'REPORT_SUMMARY'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="
                            reportSummaryTable.filterGlobal(
                    $any($event.target).value,
                    'contains'
                  )
                " placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="District">
                            {{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalAppRecieved">
                            {{'TOTAL_APP_RECIEVED'| translate}}
                            <p-columnFilter type="text" field="TotalAppRecieved" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalAppRecieved"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalAppRecievedToday">
                            {{'TOTAL_APP_RECIEVED_TODAY'| translate}}
                            <p-columnFilter type="text" field="TotalAppRecievedToday" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalAppRecievedToday"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VerifiedApplication">
                            {{'VERIFIED_APPLICATION'| translate}}
                            <p-columnFilter type="text" field="VerifiedApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="VerifiedApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="IncompleteApplication">
                            {{'INCOMPLETE_APPLICATION'| translate}}
                            <p-columnFilter type="text" field="IncompleteApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="IncompleteApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="RejectedApplication">
                            {{'REJECTED_APPLICATION'| translate}}
                            <p-columnFilter type="text" field="RejectedApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="RejectedApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingApplication">
                            {{'PENDING_APPLICATION'| translate}}
                            <p-columnFilter type="text" field="PendingApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalArea">
                            {{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalArea"></p-sortIcon>
                        </th>

                        <!-- <th pSortableColumn="">Action</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <!-- <tr [ngStyle]="{'background-color': product.Status=='Yes'  ? '#66ff66' : (product.Status=='No' ? '#ff4d4d' : '#ffffff') }"> -->
                    <tr>
                        <td>{{ product.District }}</td>
                        <td>{{ product.TotalAppRecieved }}</td>
                        <td>{{ product.TotalAppRecievedToday }}</td>
                        <td>{{ product.VerifiedApplication }}</td>
                        <td>{{ product.IncompleteApplication }}</td>
                        <td>{{ product.RejectedApplication }}</td>
                        <td>{{ product.PendingApplication }}</td>
                        <td>{{ product.TotalArea }}</td>
                        <!-- <td>
                            <button pButton pRipple type="button" (click)="takeAction(product)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                        </td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}}
                        {{ reportSummaryTableData ? reportSummaryTableData.length : 0 }} {{'REPORT_DETAIL_AVAILABLE'| translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>